module.exports = __webpack_public_path__ + "officialStatic/img/case-item.f3462e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/about/case-item.png
// module id = Zuvu
// module chunks = 0